import { BaseAttribute } from './attributes';
import { CmsProduct } from './cmsProduct';

// add new attribute names here
export const ATTR_NAMES = {
  MONTHLY_REPAYMENT: 'MONTHLY_REPAYMENT',
  HANDLING_FEE: 'HANDLING_FEE',
  INTEREST_RATE: 'INTEREST_RATE',
  BASE_ANNUAL_INTEREST_RATE: 'BASE_ANNUAL_INTEREST_RATE',
  PROCESSING_FEE: 'PROCESSING_FEE',
  MIN_COMMISSION_FEE: 'MIN_COMMISSION_FEE',
  STOCKS_SG_MIN_COMMISSION: 'STOCKS_SG_MIN_COMMISSION',
  STOCKS_US_MIN_COMMISSION: 'STOCKS_US_MIN_COMMISSION',
  MIN_DEPOSIT: 'MIN_DEPOSIT',
  MAX_BONUS_INTEREST_RATE: 'MAX_BONUS_INTEREST_RATE',
  PLATFORM_FEE_US_TEXT: 'PLATFORM_FEE_US_TEXT',
  MONTHLY_SPEND_REQUIRED: 'MONTHLY_SPEND_REQUIRED',
  ANNUAL_RATE: 'ANNUAL_RATE',
  CASHBACK_LOCAL: 'CASHBACK_LOCAL',
  CASHBACK_BONUS_CAP: 'CASHBACK_BONUS_CAP',
  MAX_INTEREST_RATE_SAVINGS: 'MAX_INTEREST_RATE_SAVINGS',
  APR: 'APR',
  INTEREST_RATE_SAVINGS: 'INTEREST_RATE_SAVINGS',
  ANNUAL_INTEREST_RATE: 'ANNUAL_INTEREST_RATE',
  PROMO_CODE: 'PROMO_CODE',
  EARN_RATE_PERKS: 'EARN_RATE_PERKS',
  TOTAL_INTEREST: 'TOTAL_INTEREST',
  INTRODUCTORY_ANNUAL_RATE: 'INTRODUCTORY_ANNUAL_RATE',
  MAXIMUM_LOAN_AMOUNT: 'MAXIMUM_LOAN_AMOUNT',
  MINIMUM_LOAN_TENURE: 'MINIMUM_LOAN_TENURE',
  TOTAL_REPAYMENT: 'TOTAL_REPAYMENT',
  DAILY_INTEREST: 'DAILY_INTEREST',
  INTRODUCTORY_MONTHLY_REPAYMENT: 'INTRODUCTORY_MONTHLY_REPAYMENT',
  WHY_APPLY_NOW: 'WHY_APPLY_NOW',

  // Personal Loan citizenship, read by the Sort & Filter panel's
  // "Your details" group (CMS-1905). MINIMUM_ANNUAL_INCOME sits with the
  // credit-card attributes below; the group reads that one too.
  CITIZENSHIP_TYPE: 'CITIZENSHIP_TYPE',

  INSUREMO_PRODUCT_UID: 'INSUREMO_PRODUCT_UID',
  // Calculated attribute (CMS-1896): the live InsureMO premium. Never authored
  // in Strapi — resolved at render from the page's travel quotes; see
  // `calculatedAttributes/registry.ts`.
  TI_PREMIUM_PRICE: 'TI_PREMIUM_PRICE',
  POLICY_WORDING_DOCUMENT_LINK: 'POLICY_WORDING_DOCUMENT_LINK',
  PRODUCT_TAG: 'PRODUCT_TAG',
  HOT_REWARD: 'HOT_REWARD',
  STEPS_TO_APPLY: 'STEPS_TO_APPLY',
  // PL Offers section closing notes (CMS-2023): HK and SG respectively.
  EXCLUSIVE_OFFER_TEXT: 'EXCLUSIVE_OFFER_TEXT',
  CC_BUNDLE_TEXT: 'CC_BUNDLE_TEXT',
  REWARD_PRODUCT_ID: 'REWARD_PRODUCT_ID',
  // Product Details Highlights lists (the CMS-1935 configured layout picks their icons by name)
  QUICK_FACTS: 'QUICK_FACTS',
  THINGS_TO_CONSIDER: 'THINGS_TO_CONSIDER',

  // TI results page ranking — CMS-1862
  STATIC_PRICE: 'STATIC_PRICE',

  // Travel Insurance coverage attributes surfaced as schema.org additionalProperty (CMS-1904)
  OVERSEAS_MEDICAL_EXPENSES: 'OVERSEAS_MEDICAL_EXPENSES',
  TRAVEL_CANCELLATION: 'TRAVEL_CANCELLATION',
  LOSS_OF_BAGGAGE_OR_PERSONAL_BELONGING:
    'LOSS_OF_BAGGAGE_OR_PERSONAL_BELONGING',
  MEDICAL_EXPENSES: 'MEDICAL_EXPENSES',
  CAR_RENTAL_EXCESS: 'CAR_RENTAL_EXCESS',
  // SingSaver uses a different relation name for the same coverage (brand split)
  RENTAL_CAR_EXCESS: 'RENTAL_CAR_EXCESS',
  // TI provider page (travel insurance) — CMS-1643 / CMS-1644
  FULFILMENT_PATH: 'FULFILMENT_PATH',
  BROCHURE_DOCUMENT_LINK: 'BROCHURE_DOCUMENT_LINK',
  MIN_AGE: 'MIN_AGE',
  MAX_AGE: 'MAX_AGE',
  CHILD_AGE_RANGE: 'CHILD_AGE_RANGE',
  RESIDENCY_REQUIREMENT: 'RESIDENCY_REQUIREMENT',
  NATIONALITY_RESTRICTION: 'NATIONALITY_RESTRICTION',
  FAMILY_PLAN: 'FAMILY_PLAN',
  GROUP_PLAN: 'GROUP_PLAN',
  CRUISE_COVERED: 'CRUISE_COVERED',

  CARD_BENEFIT: 'CARD_BENEFIT',
  ANNUAL_FEE: 'ANNUAL_FEE',
  MINIMUM_ANNUAL_INCOME: 'MINIMUM_ANNUAL_INCOME',
  SUPPORTED_PAYMENT_NETWORK: 'SUPPORTED_PAYMENT_NETWORK',
  AIRMILES_LOCAL: 'AIRMILES_LOCAL',
  CASHBACK_OVERSEAS: 'CASHBACK_OVERSEAS',
  // Credit card product card (CMS-2000)
  AIRMILES_OVERSEAS: 'AIRMILES_OVERSEAS',
  AIRMILES_LOCAL_ONLINE_SHOPPING: 'AIRMILES_LOCAL_ONLINE_SHOPPING',
  AIRMILES_OVERSEAS_ONLINE_SHOPPING: 'AIRMILES_OVERSEAS_ONLINE_SHOPPING',
  CASHBACK_LOCAL_ONLINE_SHOPPING: 'CASHBACK_LOCAL_ONLINE_SHOPPING',
  CASHBACK_OVERSEAS_ONLINE_SHOPPING: 'CASHBACK_OVERSEAS_ONLINE_SHOPPING',
  ANNUAL_FEE_WAIVER: 'ANNUAL_FEE_WAIVER',
  REGISTRATION_REQUIRED: 'REGISTRATION_REQUIRED',

  MINIMUM_COMMISSION_US: 'MINIMUM_COMMISSION_US',
  MIN_TRADING_FEE: 'MIN_TRADING_FEE',
  MIN_TRADES_FOR_REWARDS: 'MIN_TRADES_FOR_REWARDS',
  MINIMUM_COMMISSION_INTERNET: 'MINIMUM_COMMISSION_INTERNET',
  EQUITY_FUNDS_SWITCHING_FEE: 'EQUITY_FUNDS_SWITCHING_FEE',
  CRYPTO_CURRENCIES: 'CRYPTO_CURRENCIES',
  // Investments product hero chip rows — CMS-1934
  TRADING_PLATFORMS: 'TRADING_PLATFORMS',
  INVESTMENT_PRODUCTS_OFFERED: 'INVESTMENT_PRODUCTS_OFFERED',
  INVESTMENT_PAYMENT_NETWORK: 'INVESTMENT_PAYMENT_NETWORK',

  MINIMUM_ASSET_UNDER_MANAGEMENT: 'MINIMUM_ASSET_UNDER_MANAGEMENT',
  CASHBACK_REWARD: 'CASHBACK_REWARD',

  GOOGLE_RATINGS: 'GOOGLE_RATINGS',
  GOOGLE_LINK: 'GOOGLE_LINK',

  MARKETING_CONSENT: 'MARKETING_CONSENT',

  EMAIL_CAPTURE: 'EMAIL_CAPTURE',
} as const;

export type AttrValue = (typeof ATTR_NAMES)[keyof typeof ATTR_NAMES];

// add new attribute types here
const ATTRIBUTE_TYPES_MAP = {
  // number
  MONTHLY_REPAYMENT: { __typename: 'ComponentAttributesAttrNumber' },
  HANDLING_FEE: { __typename: 'ComponentAttributesAttrNumber' },
  INTEREST_RATE: { __typename: 'ComponentAttributesAttrNumber' },
  BASE_ANNUAL_INTEREST_RATE: { __typename: 'ComponentAttributesAttrNumber' },
  PROCESSING_FEE: { __typename: 'ComponentAttributesAttrNumber' },
  MIN_COMMISSION_FEE: { __typename: 'ComponentAttributesAttrNumber' },
  STOCKS_SG_MIN_COMMISSION: { __typename: 'ComponentAttributesAttrNumber' },
  STOCKS_US_MIN_COMMISSION: { __typename: 'ComponentAttributesAttrNumber' },
  MIN_DEPOSIT: { __typename: 'ComponentAttributesAttrNumber' },
  MAX_BONUS_INTEREST_RATE: { __typename: 'ComponentAttributesAttrNumber' },
  MONTHLY_SPEND_REQUIRED: { __typename: 'ComponentAttributesAttrNumber' },
  ANNUAL_RATE: { __typename: 'ComponentAttributesAttrNumber' },
  APR: { __typename: 'ComponentAttributesAttrNumber' },
  CASHBACK_LOCAL: { __typename: 'ComponentAttributesAttrNumber' },
  CASHBACK_BONUS_CAP: { __typename: 'ComponentAttributesAttrNumber' },
  INTEREST_RATE_SAVINGS: { __typename: 'ComponentAttributesAttrNumber' },
  MAX_INTEREST_RATE_SAVINGS: { __typename: 'ComponentAttributesAttrNumber' },
  ANNUAL_INTEREST_RATE: { __typename: 'ComponentAttributesAttrNumber' },
  EARN_RATE_PERKS: { __typename: 'ComponentAttributesAttrNumber' },
  TOTAL_INTEREST: { __typename: 'ComponentAttributesAttrNumber' },
  INTRODUCTORY_ANNUAL_RATE: { __typename: 'ComponentAttributesAttrNumber' },
  MAXIMUM_LOAN_AMOUNT: { __typename: 'ComponentAttributesAttrNumber' },
  MINIMUM_LOAN_TENURE: { __typename: 'ComponentAttributesAttrNumber' },
  TOTAL_REPAYMENT: { __typename: 'ComponentAttributesAttrNumber' },
  DAILY_INTEREST: { __typename: 'ComponentAttributesAttrNumber' },
  INTRODUCTORY_MONTHLY_REPAYMENT: {
    __typename: 'ComponentAttributesAttrNumber',
  },
  WHY_APPLY_NOW: { __typename: 'ComponentAttributesAttrNumber' },
  OVERSEAS_MEDICAL_EXPENSES: { __typename: 'ComponentAttributesAttrNumber' },
  TRAVEL_CANCELLATION: { __typename: 'ComponentAttributesAttrNumber' },
  LOSS_OF_BAGGAGE_OR_PERSONAL_BELONGING: {
    __typename: 'ComponentAttributesAttrNumber',
  },
  MEDICAL_EXPENSES: { __typename: 'ComponentAttributesAttrNumber' },
  CAR_RENTAL_EXCESS: { __typename: 'ComponentAttributesAttrNumber' },
  RENTAL_CAR_EXCESS: { __typename: 'ComponentAttributesAttrNumber' },
  ANNUAL_FEE: { __typename: 'ComponentAttributesAttrNumber' },
  MINIMUM_ANNUAL_INCOME: { __typename: 'ComponentAttributesAttrNumber' },
  SUPPORTED_PAYMENT_NETWORK: {
    __typename: 'ComponentAttributesAttrPaymentType',
  },
  AIRMILES_LOCAL: { __typename: 'ComponentAttributesAttrNumber' },
  CASHBACK_OVERSEAS: { __typename: 'ComponentAttributesAttrNumber' },
  AIRMILES_OVERSEAS: { __typename: 'ComponentAttributesAttrNumber' },
  AIRMILES_LOCAL_ONLINE_SHOPPING: {
    __typename: 'ComponentAttributesAttrNumber',
  },
  AIRMILES_OVERSEAS_ONLINE_SHOPPING: {
    __typename: 'ComponentAttributesAttrNumber',
  },
  CASHBACK_LOCAL_ONLINE_SHOPPING: {
    __typename: 'ComponentAttributesAttrNumber',
  },
  CASHBACK_OVERSEAS_ONLINE_SHOPPING: {
    __typename: 'ComponentAttributesAttrNumber',
  },
  MINIMUM_COMMISSION_US: { __typename: 'ComponentAttributesAttrNumber' },
  MIN_TRADING_FEE: { __typename: 'ComponentAttributesAttrNumber' },
  MIN_TRADES_FOR_REWARDS: { __typename: 'ComponentAttributesAttrNumber' },
  MINIMUM_COMMISSION_INTERNET: { __typename: 'ComponentAttributesAttrNumber' },
  EQUITY_FUNDS_SWITCHING_FEE: { __typename: 'ComponentAttributesAttrNumber' },
  MINIMUM_ASSET_UNDER_MANAGEMENT: {
    __typename: 'ComponentAttributesAttrNumber',
  },
  CASHBACK_REWARD: { __typename: 'ComponentAttributesAttrNumber' },
  CRYPTO_CURRENCIES: { __typename: 'ComponentAttributesAttrNumber' },
  // TI provider page eligibility (number)
  MIN_AGE: { __typename: 'ComponentAttributesAttrNumber' },
  MAX_AGE: { __typename: 'ComponentAttributesAttrNumber' },
  // TI results page ranking (number) — CMS-1862
  STATIC_PRICE: { __typename: 'ComponentAttributesAttrNumber' },
  // Calculated (CMS-1896): a NUMBER in the dictionary, value resolved at render.
  TI_PREMIUM_PRICE: { __typename: 'ComponentAttributesAttrNumber' },
  // number range
  CARD_BENEFIT: { __typename: 'ComponentAttributesAttrNumberRange' },
  // plain text
  PLATFORM_FEE_US_TEXT: { __typename: 'ComponentAttributesAttrPlainText' },
  PROMO_CODE: { __typename: 'ComponentAttributesAttrPlainText' },
  INSUREMO_PRODUCT_UID: { __typename: 'ComponentAttributesAttrPlainText' },
  POLICY_WORDING_DOCUMENT_LINK: {
    __typename: 'ComponentAttributesAttrPlainText',
  },
  PRODUCT_TAG: { __typename: 'ComponentAttributesAttrPlainText' },
  HOT_REWARD: { __typename: 'ComponentAttributesAttrPlainText' },
  STEPS_TO_APPLY: { __typename: 'ComponentAttributesAttrPlainText' },
  EXCLUSIVE_OFFER_TEXT: { __typename: 'ComponentAttributesAttrPlainText' },
  CC_BUNDLE_TEXT: { __typename: 'ComponentAttributesAttrPlainText' },
  REWARD_PRODUCT_ID: { __typename: 'ComponentAttributesAttrPlainText' },
  GOOGLE_LINK: { __typename: 'ComponentAttributesAttrPlainText' },
  // TI provider page (plain text)
  FULFILMENT_PATH: { __typename: 'ComponentAttributesAttrPlainText' },
  BROCHURE_DOCUMENT_LINK: { __typename: 'ComponentAttributesAttrPlainText' },
  CHILD_AGE_RANGE: { __typename: 'ComponentAttributesAttrPlainText' },
  RESIDENCY_REQUIREMENT: { __typename: 'ComponentAttributesAttrPlainText' },
  NATIONALITY_RESTRICTION: { __typename: 'ComponentAttributesAttrPlainText' },
  FAMILY_PLAN: { __typename: 'ComponentAttributesAttrPlainText' },
  GROUP_PLAN: { __typename: 'ComponentAttributesAttrPlainText' },
  CRUISE_COVERED: { __typename: 'ComponentAttributesAttrPlainText' },
  // key value
  GOOGLE_RATINGS: { __typename: 'ComponentAttributesAttrKeyValue' },
  QUICK_FACTS: { __typename: 'ComponentAttributesAttrKeyValue' },
  THINGS_TO_CONSIDER: { __typename: 'ComponentAttributesAttrKeyValue' },
  // selection — Strapi `attr-payment-network` reaches the fe as the selection
  // (payment type) attribute: cms-service serves every selection component as
  // one GraphQL type
  TRADING_PLATFORMS: { __typename: 'ComponentAttributesAttrPaymentType' },
  INVESTMENT_PRODUCTS_OFFERED: {
    __typename: 'ComponentAttributesAttrPaymentType',
  },
  INVESTMENT_PAYMENT_NETWORK: {
    __typename: 'ComponentAttributesAttrPaymentType',
  },
  // rich text
  MARKETING_CONSENT: { __typename: 'ComponentAttributesAttrRichTextEditor' },
  // multi-select. cms-service serves every dropdown attribute as a
  // `SelectionAttribute`, which fe-services maps onto this shape.
  CITIZENSHIP_TYPE: { __typename: 'ComponentAttributesAttrPaymentType' },
  // boolean
  EMAIL_CAPTURE: { __typename: 'ComponentAttributesAttrBoolean' },
  ANNUAL_FEE_WAIVER: { __typename: 'ComponentAttributesAttrBoolean' },
  REGISTRATION_REQUIRED: { __typename: 'ComponentAttributesAttrBoolean' },
} satisfies Record<AttrValue, { __typename: BaseAttribute['__typename'] }>;

type AttributeTypeByName<N extends AttrValue> = Extract<
  BaseAttribute,
  { __typename: (typeof ATTRIBUTE_TYPES_MAP)[N]['__typename'] }
>;

export function getAttrFromProduct<N extends AttrValue>(
  attrName: N,
  product?: CmsProduct,
): AttributeTypeByName<N> | undefined {
  if (!product) return undefined;
  const meta = ATTRIBUTE_TYPES_MAP[attrName];
  return product.attributes?.find(
    (a): a is AttributeTypeByName<N> =>
      a.name?.name === attrName && a.__typename === meta.__typename,
  );
}

/**
 * Returns the single attribute matching a dynamic (runtime-chosen) relation
 * name — e.g. an editor-configured TI eligibility attribute — with no
 * `__typename` narrowing. Use when the relation name is not known at authoring
 * time (so it cannot be an `ATTR_NAMES` key) and must not throw on an
 * unregistered name. For fixed relations use `getAttrFromProduct` instead.
 */
export function getAttrFromProductByName(
  name: string,
  product?: CmsProduct,
): BaseAttribute | undefined {
  if (!product || !name) return undefined;
  return product.attributes?.find((a) => a?.name?.name === name);
}

/**
 * Returns all attributes whose relation name starts with `namePrefix`, narrowed
 * to the given `__typename`. Use for dynamically-numbered relations that can't
 * be enumerated in ATTR_NAMES (e.g. `GOOGLE_REVIEW_1`, `GOOGLE_REVIEW_2`, ...).
 * Order is not guaranteed — sort by the numeric suffix at the call site.
 */
export function getAttrsFromProductByNamePrefix<
  T extends BaseAttribute['__typename'],
>(
  namePrefix: string,
  typename: T,
  product?: CmsProduct,
): Extract<BaseAttribute, { __typename: T }>[] {
  if (!product) return [];
  return (product.attributes ?? []).filter(
    (a): a is Extract<BaseAttribute, { __typename: T }> =>
      a.__typename === typename && !!a.name?.name?.startsWith(namePrefix),
  );
}
